<template>
	<div :style="backgroundUrl">
		<!-- Navbar -->
		<nav id="navbar-main" class="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg">
			<div class="container">
				<router-link class="navbar-brand" to="/">
					<img src="assets/img/brand/eThinking-pro.png" v-if="hostname == 'pro.etciberoamerica.com' || hostname == 'bpo.etciberoamerica.com'">
					<img src="assets/img/brand/eThinking-pro-white.png" v-if="hostname == 'seducoahuila.etciberoamerica.com'">
				</router-link>
			</div>
		</nav>
		<!-- Main content -->
		<div class="main-content">
			<!-- Header -->
			<div class="header py-7 py-lg-7 pt-lg-9">
				<div class="container">
					<div class="header-body text-center mt--5 mb-5">
						<div class="row justify-content-center">
							<div class="col-xl-5 col-lg-6 col-md-8 px-5">
								<h1 style="font-weight:200">Bienvenidos</h1>

							</div>
						</div>
					</div>
				</div>

			</div>
			<!-- Page content -->
			<div class="container mt--8 pb-5">
				<div class="row justify-content-center">
					<div class="col-lg-5 col-md-7">
						<div :class="classLogin">

							<div class="card-body px-lg-5 py-lg-5">
								<div :class="classUsuario">
									<img src="assets/img/bpo-academy-white-sm.png" class="mx-auto mb-4" v-if="hostname == 'bpo.etciberoamerica.com'"><br v-if="hostname == 'bpo.etciberoamerica.com'">
									<small>Recuperar contraseña</small>
								</div>
								<vue-form :state="formstate" @submit.prevent="onSubmit">
									<div class="form-group mb-3">
										<validate tag="div">
											<div class="input-group input-group-merge input-group-alternative">
												<div class="input-group-prepend">
													<span class="input-group-text"><i class="ni ni-email-83"></i></span>
												</div>
												<input class="form-control" placeholder="Correo electrónico registrado" type="email" name="email" id="email" v-model="model.email" required>
											</div>
											<field-messages name="email" show="$invalid && $submitted" class="text-danger">
	                                            <div slot="required">El correo electrónico es requerido</div>
	                                            <div slot="email">El correo electrónico no es válido</div>
	                                        </field-messages>
										</validate>
									</div>
									
									
									<div class="text-center">
										<button type="submit" class="btn btn-neutral my-2">Resetear contraseña</button>
									</div>
								</vue-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Footer -->
		<footer class="py-5" id="footer-main">
			<div class="container">
				<div class="row align-items-center justify-content-xl-between">
					<div class="col-xl-6">
						<div class="copyright text-center text-xl-left text-muted">
							&copy; 2023 <a href="https://etciberoamerica.com/" class="font-weight-bold ml-1" target="_blank">Global Certification Academy</a>
						</div>
					</div>
					<div class="col-xl-6">

					</div>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
	import options from "../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		name: 'Index',
		data() {
			return {
				formstate: {},
	            model: {
	                email: "",
	                password: "",
					captchaToken: '',
				},
				hostname: '',
				backgroundUrl: 'background-image:url(assets/img/fondos/pro-login-bg.png); background-size:cover; background-repeat:no-repeat',
				classLogin: 'card bg-gradient-default',
				classUsuario: 'text-center text-muted mb-4'
			}
		},
		methods: {
			onSubmit() {
				if (this.formstate.$invalid) {
	                return;
	            } else {
					this.openLoading()
					grecaptcha.execute('6Ldv78EZAAAAAFapAMeP1FaE4JYQDaZhsTskA119')
            		.then((token) => {
						this.model.captchaToken = token
						axios.post(apiKS + 'api/utilerias/password-recovery', this.model, { headers: clientAPI })
						.then( response => {
							Swal.close()
							if(response.data.status == true) {
								Swal.fire({
									icon: 'success',
									title: 'Exito',
									text: response.data.message,
								})
							} else {
								Swal.fire({
									icon: 'error',
									title: 'Oops...',
									text: response.data.message,
								})
							}
						}).catch(error => {
							this.catchError()
						})
					})
	            }
			}
		},
		mounted() {
			this.hostname = hostname
		},
		beforeMount() {
			document.body.classList.remove('bg-mos1')
			if(hostname == 'bpo.etciberoamerica.com') {
				this.backgroundUrl = 'background-image:url(assets/img/fondos/bpo-academy-bg.jpg); background-size:cover; background-repeat:no-repeat'
				this.classLogin = 'card bg-gradient-gray-dark'
				this.classUsuario = 'text-center text-orange mb-4'
			}

			if(hostname == 'seducoahuila.etciberoamerica.com') {
				this.backgroundUrl = 'background-image:url(assets/img/fondos/seducoahuila-bg.jpg); background-size:cover; background-repeat:no-repeat'
				this.classLogin = 'card bg-light'
				this.classUsuario = 'text-center text-purple mb-4'
				this.classForgot = 'text-purple'
			}
		}
	}
</script>